import Nodata from "./main";

export default Nodata;
